<template>
  <div class="container">
    <div class="fail">
      <div class="image">
        <img src="../../../assets/images/shareCodeFail.png" alt />
      </div>
      <!-- <p class="failText">扫码失败</p> -->
      <p class="waiting">该分享码已失效...</p>
      <div class="btns" @click="onPage">
        <button class="shopping">去首页</button>
      </div>
    </div>
  </div>
</template>
<script>
import { CellGroup, Form, Field, Toast, Overlay, Icon } from "vant";
// import { mapGetters,mapActions } from "vuex";
// import serviceRefresh from "../../api/redirect/index";
export default {
  components: {
    [CellGroup.name]: CellGroup,
    [Form.name]: Form,
    [Field.name]: Field,
    [Toast.name]: Toast,
    [Overlay.name]: Overlay,
    [Icon.name]: Icon
  },
  data() {
    return {
      isShow: true
    };
  },
  //  computed: {
  //   ...mapGetters(["userInfo"])
  // },
  mounted() {},
  methods: {
    // ...mapActions(["login", "wxLogin"]),
    onPage() {
      this.$router.replace("page");
    }
  }
};
</script>
<style lang="less">
.container {
  // height: 100%;
  background: #fff;
  .fail {
    // height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding-top: 30vw;
  }
  .image {
    width: 79px;
    height: 77px;
  }

  .button {
    height: 8vw;
    width: 18vw;
    margin: 6vw auto 3vw;
    font-size: 3.73333vw;
    background: #ee0a24;
  }

  .failText {
    color: #aaa;
    font-size: 20px;
    letter-spacing: 3px;
    font-weight: bold;
  }
  .shopping{
      width: 36vw;
     height: 36px;
  }
  .waiting {
    color: #333333;
    margin-top: 29px;
    margin-bottom: 35px;
  }
}
</style>